import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-skeleton-loader',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './skeleton-loader.component.html',
  styleUrl: './skeleton-loader.component.scss'
})
export class SkeletonLoaderComponent {
  @Input() formLoader: boolean = false;
  @Input() pingLoder: boolean = false;
  @Input() loadingText: string = "";
  @Input() noOfFields: any = 3;

}
